import React from 'react';
import { cn } from '../../lib/utils';

const WORKSPACE_CARD = {
  agency: 'border-slate-200 bg-white',
  platform: 'border-zinc-700/80 bg-zinc-900/50',
};

/**
 * GHL-style builder body: full-width graph workspace + right editor overlay.
 * The editor never shrinks the workspace used for graph coordinate measurement.
 */
const WorkflowBuilderBodyLayout = ({
  variant = 'agency',
  workspace,
  editorPanel = null,
  editorPanelWidth = 0,
  editorOverlayMode = false,
  onEditorOverlayDismiss,
}) => {
  const showEditorSlot = Boolean(editorPanel) && editorPanelWidth > 0;

  return (
    <div
      className="relative flex min-h-0 min-w-0 flex-1 p-3"
      data-workflow-builder-body
      data-editor-overlay-mode={editorOverlayMode ? 'true' : 'false'}
      data-workflow-editor-open={showEditorSlot ? 'true' : 'false'}
    >
      {editorOverlayMode && showEditorSlot && onEditorOverlayDismiss ? (
        <button
          type="button"
          aria-label="Close editor"
          className="absolute inset-3 z-40 rounded-xl bg-slate-900/20 backdrop-blur-[1px]"
          data-testid="workflow-editor-overlay-backdrop"
          onClick={onEditorOverlayDismiss}
        />
      ) : null}

      <section
        className={cn(
          'relative z-0 flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border shadow-sm',
          WORKSPACE_CARD[variant] || WORKSPACE_CARD.agency,
        )}
        data-workflow-workspace-panel
        data-workflow-graph-coordinate-root
      >
        {workspace}
      </section>

      {showEditorSlot ? (
        <div
          className="pointer-events-none absolute inset-3 z-50 flex justify-end"
          data-workflow-editor-panel-slot
          data-workflow-editor-overlay-slot="true"
          data-editor-panel-width={editorPanelWidth}
        >
          <aside
            className="pointer-events-auto flex h-full min-h-0 shrink-0 flex-col overflow-hidden"
            style={{ width: editorPanelWidth }}
          >
            {editorPanel}
          </aside>
        </div>
      ) : null}
    </div>
  );
};

export default WorkflowBuilderBodyLayout;
